// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableLog .table-responsive-sm table{table-layout:fixed;overflow-wrap:break-word}", ""]);
// Exports
module.exports = exports;
